import React from 'react';
import PropTypes from 'prop-types';

class RiskFingerprint extends React.Component {
    static propTypes = {
        orgId: PropTypes.string.isRequired,
        deviceId: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const orgId = this.props.orgId;
        const deviceId = this.props.deviceId;

        let divUrl = `https://tmcdn.homeaway.com/fp/clear.png?org_id=${orgId}&session_id=${deviceId}&m=1`;
        let imgUrl = `https://tmcdn.homeaway.com/fp/clear.png?org_id=${orgId}&session_id=${deviceId}&m=2`;
        let scriptUrl = `https://tmcdn.homeaway.com/fp/check.js?org_id=${orgId}&session_id=${deviceId}&pageid=1`;
        let objectUrl = `https://tmcdn.homeaway.com/fp/fp.swf?org_id=${orgId}&session_id=${deviceId}`;
        let objectMovieUrl = `https://tmcdn.homeaway.com/fp/fp.swf?org_id=${orgId}&session_id=${deviceId}`;
        return (
            <div>
                <div id="rfDiv" styles={divUrl}/>
                <img id="rfImg" src={imgUrl} alt={''}/>
                <script id="rfScript" src={scriptUrl}/>
                <object id="rfObj" width={1} height={1} data={objectUrl} type={'application/x-shockwave-flash'}>
                    <param id="rfObjParam" value={objectMovieUrl} name={'movie'}/>
                    <param value="transparent" name={'wmode'}/>
                </object>
            </div>
        );
    }
}

export default RiskFingerprint;
